import React from "react";
import { useSubheader } from "../../../_metronic/layout";
import StudentFamilyFilterSearch from "./components/StudentFamilyFilterSearch";
import StudentFamilyBranchTable from "./components/StudentFamilyBranchTable";

export const StudentFamilyBranchList = () => {
  const suhbeader = useSubheader();
  suhbeader.setTitle("Student Family Branch");

  return (
    <>
      <div className="card card-custom">
        <div className="card-header border-0 py-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">
              Student Family Branch Filters
            </span>
          </h3>
        </div>
        <div className="card-body">
          <StudentFamilyFilterSearch />
        </div>
      </div>
      <StudentFamilyBranchTable />
    </>
  );
};
